import dayjs from 'dayjs';
import { HttpResponse } from '@angular/common/http';
import { downloadBlob } from './download-blob';

export const downloadDocument = function (response: HttpResponse<any>): void {
  // Extrahiere Dateinamen aus Content-Disposition Header
  const contentDisposition = response.headers.get('content-disposition');
  let downloadFileName = `document_${dayjs().format('YYYY-MM-DD')}.docx`;

  if (contentDisposition) {
    // RFC 5987: filename*=UTF-8''encoded hat Vorrang vor filename="..."
    const filenameStarMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (filenameStarMatch && filenameStarMatch[1]) {
      downloadFileName = decodeURIComponent(filenameStarMatch[1].trim());
    } else {
      const filenameMatch = contentDisposition.match(/filename="?([^";]+)"?/);
      if (filenameMatch && filenameMatch[1]) {
        downloadFileName = filenameMatch[1].trim();
      }
    }
  }

  // Extrahiere MIME-Type aus Content-Type Header
  const contentType = response.headers.get('content-type') ?? 'application/octet-stream';

  // Erstelle Blob mit korrektem MIME-Type und lade herunter
  const blob = new Blob([response.body], { type: contentType });
  downloadBlob(blob, downloadFileName);
};
